import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdsCampaignArea } from '../classes/ads-campaign-area';

@Injectable({
  providedIn: 'root'
})
export class AdsCampaignAreaService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  public delete(adsCampaignId: number, adsCampaignAreaId: number): Observable<void> {
    return this.httpClient.delete<void>(`/api/media/campaigns/${adsCampaignId}/areas/${adsCampaignAreaId}`);
  }

  public get(adsCampaignId: number, adsCampaignAreaId: number): Observable<AdsCampaignArea> {
    return this.httpClient.get<AdsCampaignArea>(`/api/media/campaigns/${adsCampaignId}/areas/${adsCampaignAreaId}`);
  }

  public save(adsCampaignId: number, adsCampaignAreaId: number | null, adsCampaignArea: AdsCampaignArea): Observable<AdsCampaignArea> {
    return this.httpClient.post<AdsCampaignArea>(`/api/media/campaigns/${adsCampaignId}/areas/${adsCampaignAreaId ? adsCampaignAreaId : ''}`, adsCampaignArea);
  }
}
